import React from 'react';
import { avatarOptions, getAvatar } from '../../lib/domain-data';

/**
 * One avatar tile. Draws the character art when the client's set has arrived
 * and the placeholder emoji until then, so no caller has to know which.
 */
export const AvatarBadge: React.FC<{ avatarId: string | null | undefined; size?: number }> = ({
  avatarId,
  size = 48
}) => {
  const avatar = getAvatar(avatarId);
  return (
    <span
      className="avatar-badge"
      style={{ width: size, height: size, background: avatar.color, fontSize: size * 0.55 }}
      aria-hidden="true"
    >
      {avatar.image ? <img src={avatar.image} alt="" /> : avatar.emoji}
    </span>
  );
};

interface AvatarPickerProps {
  value: string | null;
  onChange: (avatarId: string) => void;
  disabled?: boolean;
  /** Radio group name, so two pickers on one page stay independent. */
  name?: string;
}

/**
 * FR-02 character picker (SoW Bagian 2.2).
 *
 * Native radio inputs under the tiles: arrow keys move between characters and
 * a screen reader announces "Singa, 1 of 8", with no custom keyboard handling
 * to get wrong.
 */
export const AvatarPicker: React.FC<AvatarPickerProps> = ({
  value,
  onChange,
  disabled = false,
  name = 'avatar'
}) => (
  <fieldset className="field avatar-field" disabled={disabled}>
    <legend>Pilih karakter</legend>
    <div className="avatar-grid">
      {avatarOptions.map(option => (
        <label
          key={option.id}
          className={`avatar-option${value === option.id ? ' selected' : ''}`}
        >
          <input
            type="radio"
            className="sr-only"
            name={name}
            value={option.id}
            checked={value === option.id}
            onChange={() => onChange(option.id)}
          />
          <AvatarBadge avatarId={option.id} size={52} />
          <span className="avatar-option-label">{option.label}</span>
        </label>
      ))}
    </div>
  </fieldset>
);

export default AvatarPicker;
